import axios from 'axios';

export default {
  getAll(params = {}) {
    return axios.get('/v1/groups', { params });
  },
  getHierarchy(params = {}) {
    return axios.get('/v1/hierarchies', { params });
  },
  getDraftHierarchy(params = {}) {
    return axios.get('/v1/draft/hierarchies', { params });
  },
  detailHierarchy(id) {
    return axios.get(`/v1/divisions/structure/${id}`);
  },
  detailDraftHierarchy(id) {
    return axios.get(`/v1/draft/hierarchies/${id}`);
  },
  detailGroup(id) {
    return axios.get(`/v1/groups/${id}`);
  },
  getGroup(params = {}) {
    return axios.get('/v1/groups/list/groups', { params });
  },
  getBO(params = {}) {
    return axios.get('/v1/groups/list/budget-owners', { params });
  },
  createGroup(data) {
    return axios.post('/v1/groups', data);
  },
  deleteGroup(id) {
    return axios.delete(`/v1/groups/${id}`);
  },
  updateGroup(id, params) {
    return axios.patch(`/v1/groups/${id}`, params);
  },
  updateDraft(id, params) {
    return axios.patch(`/v1/draft/hierarchies/update/${id}`, params);
  },
  updateApply(id, params) {
    return axios.patch(`/v1/draft/hierarchies/apply/${id}`, params);
  },
  createHierarchy(data) {
    return axios.post('/v1/hierarchies', data);
  },
  applyHierarchy(data) {
    return axios.post('/v1/draft/hierarchies/apply', data);
  },
  createDraft(data) {
    return axios.post('/v1/draft/hierarchies/create', data);
  },
  getLevel(params = {}) {
    return axios.get('/v1/levels', { params });
  },
  saveLevel(data) {
    return axios.post('/v1/levels', data);
  }
};
